module.exports = __webpack_public_path__ + "static/media/equick-china.d15ef219.svg";